import useCallProvider from './useCallProvider';
import useFonemaCallActions from '../fonema/actions/useFonemaCallActions';
import useVoiceCallActionsBridge from '../voice/application/useVoiceCallActionsBridge';
import { useWhatsappCallsRuntime } from './WhatsappCallsRuntimeContext';

/**
 * Call actions for the active provider. Inside call manager only one backend hook runs.
 * Outside the manager (e.g. call sidebar), falls back to retailer config with enabled flags.
 *
 * @param {Object} params
 */
export default function useWhatsappCallActions(params) {
  const { provider: contextProvider } = useWhatsappCallsRuntime();
  const retailerProvider = useCallProvider();
  const provider = contextProvider ?? retailerProvider;

  const fonemaActions = useFonemaCallActions({
    ...params,
    enabled: provider === 'fonema'
  });
  const voiceActions = useVoiceCallActionsBridge({
    ...params,
    enabled: provider === 'voice'
  });

  if (provider === 'voice') {
    return voiceActions;
  }
  return fonemaActions;
}
